import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";

// details vem de: SubscriberController.findDetails → findSubscription(id) → API GET subscriptions/store/list/:id → format.subscriber(data.subscription) → setDetails()
export function AlertChangeCard() {
  const details = useSubscribers(st => st.data.details)

  const CSubscriber = SubscriberController();

  if (!details) return null

  const email = details.customer?.email?.trim?.() || ''

  const semEmail = !email

  return (
    <Alert.Root name={CSubscriber.changeCreditCardAlertName}>
      <Alert.Content>
        {semEmail ? (
          <>
            <Alert.Title>🚫 Não é possível enviar o link</Alert.Title>
            <p className="mb-10">
              Este cliente não possui e-mail cadastrado. Por isso, não é possível enviar o link.
            </p>
            <Alert.Actions>
              <Alert.Cancel>Voltar</Alert.Cancel>
            </Alert.Actions>
          </>
        ) : (
          <>
            <Alert.Title>Alterar Cartão</Alert.Title>
            <ul className="sp ace-y-3 mb-10">
              <li>Cliente irá receber por Email um link para troca do cartão;</li><br />
              <li>Quando entrar nesse link, cliente deve preencher os dados e clicar em <strong className="highlight">Atualizar</strong></li><br />
              <li>Pronto! Caso o cliente tenha fatura em atraso será feita uma cobrança, senão só será trocado o cartão para próxima cobrança.</li><br />
              <li>O link expira em até 24 horas;</li><br />
              <li><strong className="highlight">📱 A troca de cartão também está disponível no app</strong></li><br />
              <p className="mb-3 font-medium text-lg">E-mail de envio: {email}</p>
            </ul>

            <Alert.Actions>
              <Alert.Cancel>Cancelar</Alert.Cancel>
              <Alert.Confirm
                onClick={() => CSubscriber.changeCreditCardSubscribers(false, true)}
              >
                Enviar Email
              </Alert.Confirm>
            </Alert.Actions>
          </>
        )}
      </Alert.Content>
    </Alert.Root>
  )
}
